/* Zapasowe ustawienia Loanti Social Proof. Gdy backend nie odpowie, motyw używa tych wartości. */
window.LoantiSocialProofConfig = {
  enabled: true,
  apiBase: 'https://importer.4volte.pl/public/social-proof',

  purchasePopup: {
    enabled: true,
    text: 'Ktoś właśnie kupił',
    displaySeconds: 6.5,
    pages: { product: true, collection: true, home: true, cart: false, blog: false, page: false }
  },

  cartPopup: {
    enabled: true,
    text: 'Ktoś dodał ten produkt do koszyka',
    displaySeconds: 6.5,
    pages: { product: true, collection: true, home: true, cart: false, blog: false, page: false }
  },

  viewerCounter: {
    enabled: true,
    minCount: 1
  },

  soldCounter: {
    enabled: true,
    days: 30,
    minCount: 1
  },

  frequency: {
    maxPopups: 3,
    windowMinutes: 30,
    initialMin: 12,
    initialMax: 20,
    nextMin: 35,
    nextMax: 60,
    thirdMin: 45,
    thirdMax: 90
  },

  randomDelays: true,
  allowRepeatEvent: false,
  keepLimitOnRefresh: true,
  muteAfterAddToCartSeconds: 120,
  desktopPosition: 'left',
  mobilePosition: 'above-sticky',
  debug: false
};
